<template>
  <v-app></v-app>
</template>

<script>

export default {
  name: 'Logout',
}
</script>